import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_grid_layout = _resolveComponent("grid-layout");
  return _openBlock(), _createBlock(_component_grid_layout, {
    class: "gridLayoutContainer"
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("div", {
      class: "accessibility-statement-block"
    }, [_createElementVNode("iframe", {
      class: "accessibility-statement-iframe",
      id: "accessibility-statement-iframe"
    })], -1)])),
    _: 1,
    __: [0]
  });
}